import RequestBehaviour from '../base/RequestBehaviour';

export default class LookupContinueTransaction extends RequestBehaviour {
	/**
	 * Cardinal transaction indentifier
	 */
	identifier?: string = undefined;

	/**
	 * Cardinal Validation JWT payload
	 */
	payload?: string = undefined;

	/**
	 * Tokenized card identifier (T-* format)
	 */
	card_token?: string | null = undefined;

	/**
	 * Cardinal authentication flag for tokenization
	 */
	authenticate_token: boolean = false;
}
